<template>
  <div v-loading="loading">
    <div>{{ param.name }}</div>
    <div
      style="width: 100%; height: calc(100vh - 242px)"
      id="abGraphChart"
    ></div>
    <div v-show="assetLinkShow" class="lineAssetwarp">
      <div style="text-align: right">
        <div style="position: absolute; margin-left: 10px">
          <span style="font-size: 14px; font-weight: bold">{{
            nowChooseedge.name
          }}</span>
        </div>
        <i
          class="iconfont icon-close btn"
          title="关闭"
          @click="handleHideAssetWarp"
        ></i>
        <div
          style="text-align: left; margin-top: 4px"
          v-for="asset_path in nowChooseedge.asset_path"
          :key="asset_path"
        >
          <el-tag style="margin-left: 5px">{{
            showEndName(asset_path)
          }}</el-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineExpose, defineEmits, nextTick, reactive, ref } from "vue";
import * as echarts from "echarts";
import {
  apiPackageParseBundleBetweenAsset,
  apiPackageParseGraph,
} from "@/Api/AppApi";

const emit = defineEmits(["graphChartClick"]);
defineExpose({ init, clear });

function showEndName(name) {
  const l = name.split("/");
  return l[l.length - 1];
}

const param = reactive({
  name: "",
  versionid: "",
});
function init(p) {
  for (const key in p) {
    param[key] = p[key];
  }
  loadData(p);
}

let myChart = null;
function clear() {
  param.name = "";
  if (myChart != null) {
    echarts.dispose(myChart);

    myChart = null;
  window.onresize = undefined;
  }
}

function initChart() {
  document.oncontextmenu = function () {
    return false;
  };
  myChart = echarts.init(document.getElementById("abGraphChart"));
  myChart.on("click", (params) => {
    if (params.dataType === "edge") {
      // 点击的是边 则查询关联的资源
      assetLinkShow.value = true;
      nowChooseedge.name = params.name;
      loadLinkData(params);
    } else if (params.dataType === "node") {
      // 点击的是点 则查询 下一级
      addLoadData(params);
    }
  });
  myChart.on("contextmenu", (params) => {
    if (params.dataType === "node") {
      // 右键点击穿透
      const data = {
        viewType: "boundledetail",
        name: params.name,
      };
      emit("graphChartClick", data);
    }
  });

  window.onresize = myChart.resize;
}
const chartOption = {
  title: {
    text: "AB包关系图",
    top: "bottom",
    left: "right",
  },
  legend: {},
  animation: false,
  series: [
    {
      name: "AB包",
      type: "graph",
      layout: "force",
      animation: false,
      data: [],
      links: [],
      categories: [],
      roam: true,
      lineStyle: {
        width: 2,
        opacity: 1,
        curveness: 0.1,
      },
      label: {
        show: true,
        position: "inside",
      },
      force: {
        repulsion: 100,
        edgeLength: [50, 90],
      },
      focusNodeAdjacency: true,
    },
  ],
  chartdata: {},
};
function drawChart(addParams) {
  nextTick(() => {
    if (myChart === null) {
      initChart();
    }
    const nodes = [];
    let maxCategory = 0;
    for (let i = 0; i < chartData.node.length; i++) {
      const node = chartData.node[i];
      if (maxCategory < node.level) {
        maxCategory = node.level;
      }
      if (i === 0) {
        nodes.push({
          name: node.name,
          symbolSize: 20,
          child: 0,
          category: node.level,
          label: {
            formatter: node.name,
          },
          x: myChart.getWidth() / 2,
          y: myChart.getHeight() / 2,
          fixed: true,
        });
      } else {
        const temp = {
          name: node.name,
          itemStyle: null,
          symbolSize: 15,
          child: node.child,
          category: node.level,
          draggable: true,
          label: {
            formatter: node.name + "(" + node.child + ")",
          },
        };
        if (addParams != undefined && addParams.data.name === node.name) {
          temp.itemStyle = {
            color: "#56cefc",
          };
          temp.symbolSize = 20;
          temp.x = addParams.event.offsetX;
          temp.y = addParams.event.offsetY;
          temp.fixed = true;
        }
        nodes.push(temp);
      }
    }
    const category = [];
    for (let i = 0; i <= maxCategory; i++) {
      category.push({ name: "第" + (i + 1) + "级" });
    }
    const option = JSON.parse(JSON.stringify(chartOption));
    option.legend.data = category;
    option.series[0].data = nodes;
    option.series[0].links = chartData.edges;
    option.series[0].categories = category;
    myChart.setOption(option);
  });
}

async function loadLinkData(p) {
  const params = {
    version_id: param.versionid,
    from: p.data.source,
    to: p.data.target,
  };
  const res = await apiPackageParseBundleBetweenAsset(params);
  if (res.code === 0) {
    nowChooseedge.asset_path = res.data.asset_path;
  }
}
async function addLoadData(p) {
  if (p.data.child !== 0) {
    const params = {
      origin: p.data.name,
      version_id: param.versionid,
      level: p.data.category,
      add_level: 1,
    };
    loading.value = true;
    const res = await apiPackageParseGraph(params);
    loading.value = false;

    if (res.code === 0) {
      const oldNode = chartData.node;
      const newNode = res.data.node;
      for (const node of newNode) {
        if (!oldNode.some((o) => o.name === node.name)) {
          oldNode.push(node);
        }
      }

      const oldEdges = chartData.edges;
      const newEdges = res.data.edges;
      for (const edge of newEdges) {
        if (
          !oldEdges.some(
            (e) => e.source === edge.source && e.target === edge.target
          )
        ) {
          oldEdges.push(edge);
        }
      }

      drawChart(p);
    }
  }
}

let chartData = null;
const loading = ref(false);
async function loadData(p) {
  const params = {
    origin: p.name,
    version_id: p.versionid,
    level: 0,
    add_level: 2,
  };
  loading.value = true;
  const res = await apiPackageParseGraph(params);
  loading.value = false;

  if (res.code === 0) {
    chartData = res.data;
    drawChart();
  }
}

const assetLinkShow = ref(false);
const nowChooseedge = reactive({
  name: "",
  asset_path: [],
});
function handleHideAssetWarp() {
  nowChooseedge.name = "";
  nowChooseedge.asset_path = [];
  assetLinkShow.value = false;
}
</script>

<style scoped lang="scss">
.lineAssetwarp {
  width: 300px;
  height: 230px;
  position: absolute;
  border: 1px solid #d0cfcf;
  left: 0px;
  bottom: 0;
  overflow: auto;
}

.btn {
  font-size: 16px;
  cursor: pointer;
}
.btn:hover {
  color: #1a7dd7;
}
</style>
